import i18n from "../i18n/i18n";

export function getLanguage() {
  return i18n.resolvedLanguage || i18n.language || "en";
}

export function t(key, values = {}) {
  return i18n.t(key, values);
}

// 兼容现有页面的 lang.next 调用；新组件推荐直接使用 useTranslation。
export const lang = new Proxy({}, { get: (_, key) => i18n.t(key) });
